import { Navigate, RouteObject } from 'react-router-dom';
import { AppWrapper } from '../layout/AppWrapper';
import { ProtectedAdminRoute } from '../layout/ProtectedAdminRoute';
import Dashboard from '../pages/app/Dashboard';
import ActivitiesList from '../pages/app/activities/ActivitiesList';
import OrganisationsList from '../pages/app/organisations/OrganisationsList';
import OrganisationView from '../pages/app/organisations/OrganisationView';
import UsersList from '../pages/app/users/UsersList';
import UserView from '../pages/app/users/UserView';
import CouponsList from '../pages/app/coupons/CouponsList';
import CouponView from '../pages/app/coupons/CouponView';
import AffiliatesList from '../pages/app/affiliates/AffiliatesList';
import AffiliateView from '../pages/app/affiliates/AffiliateView';
import Login from '../pages/auth/Login';
import { AuthCallbackPage } from '../pages/auth/AuthCallbackPage';
import AuthPopupBridge from '../pages/auth/AuthPopupBridge';

export const routes: RouteObject[] = [
  // Root redirect
  {
    path: '/',
    element: <Navigate to="/app" replace />,
  },

  // Auth routes
  {
    path: '/login',
    element: <Login />,
  },

  // OAuth callback
  {
    path: '/auth/callback',
    element: <AuthCallbackPage />,
  },

  // OAuth bridge for popup
  {
    path: '/auth/bridge',
    element: <AuthPopupBridge />,
  },

  // Main app routes (admin protected)
  {
    path: '/app',
    element: (
      <ProtectedAdminRoute>
        <AppWrapper />
      </ProtectedAdminRoute>
    ),
    children: [
      {
        path: '',
        element: <Dashboard />,
      },
      {
        path: 'activities',
        element: <ActivitiesList />,
      },
      {
        path: 'organisations',
        element: <OrganisationsList />,
      },
      {
        path: 'organisations/:organisationId',
        element: <OrganisationView />,
      },
      {
        path: 'users',
        element: <UsersList />,
      },
      {
        path: 'users/:userId',
        element: <UserView />,
      },
      {
        path: 'coupons',
        element: <CouponsList />,
      },
      {
        path: 'coupons/:couponId',
        element: <CouponView />,
      },
      {
        path: 'affiliates',
        element: <AffiliatesList />,
      },
      {
        path: 'affiliates/:affiliateAccountId',
        element: <AffiliateView />,
      },
    ],
  },

  // 404 fallback
  {
    path: '*',
    element: <Navigate to="/app" replace />,
  },
];
